import { createSlice } from '@reduxjs/toolkit';
import { dispatch } from 'src/redux/store';
import axios from 'src/utils/axios';

const initialState = {
    error: null,
    planId: null,
    paymentMethodId: null,
    isPlanLoading: false,
    plan: null,
    plans: null,
    isModuleLoading: false,
    modules: null,
    isPaymentMethodLoading: false,
    paymentMethods: null,
    planType: null,
};

const slice = createSlice({
    name: 'planApi',
    initialState,
    reducers: {
        // START LOADING
        startPlanLoading(state) {
            state.isPlanLoading = true;
        },
        startModuleLoading(state) {
            state.isModuleLoading = true;
        },
        startPaymentMethodLoading(state) {
            state.isPaymentMethodLoading = true;
        },
        // HAS ERROR
        hasError(state, action) {
            state.isFaqGroupLoading = false;
            state.isPlanLoading = false;
            state.isPaymentMethodLoading = false;
            state.error = action.payload;
        },
        // SET DATA
        setPlans(state, action) {
            state.isPlanLoading = false;
            state.plans = action.payload;
        },
        setPlanId(state, action) {
            state.planId = action.payload.id;
            state.planType = action.payload.planType
        },
        setPlan(state, action) {
            state.plan = action.payload;
        },
        setModules(state, action) {
            state.isModuleLoading = false;
            state.modules = action.payload;
        },
        setPaymentMethods(state, action) {
            state.isPaymentMethodLoading = false;
            state.paymentMethods = action.payload;
        },
        setPaymentMethod(state, action) {
            state.paymentMethodId = action.payload;
        },
    },
});

// Reducer
export default slice.reducer;

// Actions
export const {
    startPlanLoading,
    startModuleLoading,
    startPaymentMethodLoading,
    setPlanId,
    setPlan,
    setPaymentMethod,
    hasError,
} = slice.actions;

// ----------------------------------------------------------------------

export function getPlans() {
    return async () => {
        dispatch(slice.actions.startPlanLoading());
        try {
            const response = await axios.get(`/api/catalog/plans`);
            dispatch(slice.actions.setPlans(response.data));
        } catch (error) {
            dispatch(slice.actions.hasError(error));
        }
    };
}

export function getPlan(id) {
    return async () => {
        dispatch(slice.actions.startPlanLoading());
        try {
            const response = await axios.get(`/api/catalog/plan/${id}`);
            dispatch(slice.actions.setPlan(response.data));
        } catch (error) {
            dispatch(slice.actions.hasError(error));
        }
    };
}

export function getPaymentMethods() {
    return async () => {
        dispatch(slice.actions.startPaymentMethodLoading());
        try {
            const response = await axios.get(`/api/catalog/payment_methods`);
            dispatch(slice.actions.setPaymentMethods(response.data));
        } catch (error) {
            dispatch(slice.actions.hasError(error));
        }
    };
}